// Persisted per-device preference: should the ghost-style overlay auto-open when
// ghosting turns on? Defaults to ON — the user asked for the style controls to
// surface by default the moment ghosting activates, overridable and remembered.
// Key is btoa-obfuscated to match the app's localStorage convention (see the
// `focusMode` / `hideKeyboard` keys).
const GHOST_AUTO_SHOW_KEY = btoa('ghostAutoShowOverlay');

/**
 * @returns {boolean} true unless the user has explicitly opted out. Unset = default ON.
 */
export function readGhostAutoShow() {
  try {
    const raw = window.localStorage.getItem(GHOST_AUTO_SHOW_KEY);
    return raw === null ? true : raw === 'true';
  } catch (err) {
    // Storage blocked (e.g. Safari private mode) — fall back to the default.
    return true;
  }
}

/**
 * @param {boolean} value
 */
export function writeGhostAutoShow(value) {
  try {
    window.localStorage.setItem(GHOST_AUTO_SHOW_KEY, String(!!value));
  } catch (err) {
    // Storage unavailable — the choice stays in memory for this session only.
  }
}
